import React from 'react';
import Slider from "../../../../assets/images/sliders 1.svg";
import newExcel from "../../../../assets/images/FileXls.svg";
import CustomButton from 'Samarth Module/components/buttons/CustomButton';
import OverviewTable from 'Samarth Module/components/table/QCommTables/OverviewTable';
import styles from './dispatchPriority.module.css';
import HighRiskSkuTable from 'Samarth Module/components/table/QCommTables/HighRiskSkuTable';

export default function DispatchTable({ tableData = [], label, sortableColumns, columns, expandingCustomerskuData, paginationData, sortingData, handleOpenCustomization, handlePageChange, handleExport, isCustomizable = true }) {

    // Logic to export table data to Excel
    const handleExportToExcel = () => {
        if(!handleExport) return;
        handleExport(label);
    };

    // Logic to handle customization
    const handleCustomization = () => {
        handleOpenCustomization();
    };

    return (
        <>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <p className={styles.title}>{label}</p>
            <div style={{ display: 'flex', columnGap: '10px'}}>
            {label === 'Overview' && isCustomizable && <CustomButton icon={Slider} label="Customise" type="mm-save" onClick={handleCustomization}/>}
            <CustomButton icon={newExcel} label="Export" type="mm-save" onClick={handleExportToExcel}/>
            </div>
        </div>
        {label !== 'Overview' ?
            <HighRiskSkuTable tableData={tableData} sortableColumns={sortableColumns} columns={columns} label={label} expandingRow={expandingCustomerskuData} /> :
            <OverviewTable tableData={tableData} paginationData={paginationData} columns={columns} sortingData={sortingData} handlePageChange={handlePageChange} />
        }
        </>
    );
}